/**
 * Main Home page
 */
import React from "react";
import Container from "../components/core/Container";
import HomeClubsDisplay from "../components/home/HomeClubsDisplay";
import ShortcutsMain from "../components/home/ShortcutsMain";
import HomeGradient from "../components/home/HomeGradient";
import { Helmet } from "react-helmet-async";
import HomeNews from "../components/home/HomeNews";

const Home = () => {
  return (
    <>
      {/* Header will be displayed before this */}
      <Helmet>
        <title>Homepage | BUIHA</title>
        <meta
          name="description"
          content={`Official website of the British Universities Ice Hockey Association. The BUIHA is the governing body for University Ice Hockey in Great Britain.`}
        />
        <link rel="canonical" href={`https://buiha.org`} />
        <link rel="icon" type="image/png" href="/favicon.png" />

      </Helmet>
      <HomeGradient />

      <Container
        children={
          <div className="flex flex-col items-center justify-center bg-light-1 dark:bg-dark-1">
            <HomeClubsDisplay />
            <HomeNews />
            <ShortcutsMain />
            {/*<MiniVidsHero />*/}
          </div>
        }
      />
    </>
  );
};

export default Home;
